document.addEventListener('click', function (evt) {
  var btn = evt.target.closest('[data-orthonica-buy-now]');
  if (!btn) return;
  if (btn.getAttribute('aria-disabled') === 'true') return;

  var form = document.getElementById(btn.dataset.formId);
  if (!form) return;

  var spinner = btn.querySelector('.loading__spinner');

  function setLoading(isLoading) {
    if (isLoading) {
      btn.setAttribute('aria-disabled', 'true');
      btn.classList.add('loading');
      if (spinner) spinner.classList.remove('hidden');
    } else {
      btn.removeAttribute('aria-disabled');
      btn.classList.remove('loading');
      if (spinner) spinner.classList.add('hidden');
    }
  }

  setLoading(true);

  var formData = new FormData(form);

  fetch(window.routes.cart_add_url, {
    method: 'POST',
    headers: {
      'X-Requested-With': 'XMLHttpRequest',
      Accept: 'application/json',
    },
    body: formData,
  })
    .then(function (response) {
      return response.json();
    })
    .then(function (data) {
      if (data.status) {
        setLoading(false);
        console.error('Buy Now: could not add to cart', data);
        return;
      }
      window.location.href = '/checkout';
    })
    .catch(function (error) {
      setLoading(false);
      console.error(error);
    });
});
